export const parseTimeToMinutes = (timeValue) => {
    if (!timeValue || typeof timeValue !== 'string') {
        return 0;
    }

    const match = timeValue.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
    if (!match) {
        return 0;
    }

    let hours = Number(match[1]);
    const minutes = Number(match[2]);
    const meridiem = (match[3] || '').toUpperCase();

    if (meridiem === 'AM' && hours === 12) hours = 0;
    if (meridiem === 'PM' && hours !== 12) hours += 12;

    return hours * 60 + minutes;
};

export const formatMinutesAsTime = (totalMinutes) => {
    const safeMinutes = Number.isFinite(totalMinutes) ? totalMinutes : 0;
    const normalized = ((safeMinutes % 1440) + 1440) % 1440;
    const hours = Math.floor(normalized / 60);
    const minutes = normalized % 60;
    const suffix = hours >= 12 ? 'PM' : 'AM';
    const normalizedHours = hours % 12 === 0 ? 12 : hours % 12;

    return `${normalizedHours}:${String(minutes).padStart(2, '0')} ${suffix}`;
};
